// extracted by mini-css-extract-plugin
module.exports = {"root":"Prices_root__pYeRO","request":"Prices_request__2Gx3d","title":"Prices_title__1LyML"};